import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
//
const Admin = () => {
  const [product, setProduct] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/product`)
      .then((response) => {
        setProduct(response.data.data);
        setFilteredProducts(response.data.data.reverse());

        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, []);

  const filterProducts = () => {
    if (!Array.isArray(product)) {
      console.error("Products is not an array:", product);
      return;
    }

    let filtered = [...product];

    if (searchTerm !== "") {
      const terms = searchTerm
        .toLowerCase()
        .split(" ")
        .filter((term) => term !== "");
      filtered = filtered.filter((product) =>
        terms.every(
          (term) =>
            product.evento.toLowerCase().includes(term) ||
            product.tags.toLowerCase().includes(term) ||
            product.local.toLowerCase().includes(term)
        )
      );
    }
    setFilteredProducts(filtered);
  };

  useEffect(() => {
    filterProducts();
  }, [product, searchTerm]);

  return (
    <div className="px-4 py-8 max-w-7xl mx-auto mt-16">
      {/* <Stats /> */}
      <div className="form-control flex mx-auto m-4">
        <label className="label">
          <span className="label-text">Filtrar</span>
        </label>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Digite para filtrar"
          className="input input-bordered w-full max-w-xs"
        />
      </div>
      <div className="overflow-x-auto">
        <table className="table">
          <thead>
            <tr>
              <th>
                <Link
                  to="/admin/product/create"
                  className="bg-green-600 hover:bg-green-900 py-2 px-4 font-medium rounded-lg 
                              shadow-md text-base-100"
                >
                  Novo
                </Link>
              </th>
              <th>Local</th>
              <th>Preço</th>
              <th>Tags</th>
              <th>Atleta</th>
              <th>Evento</th>
            </tr>
          </thead>

          <tbody>
            {filteredProducts.map((product, index) => (
              <tr key={product._id} className="bg-base-100 hover:bg-base-300">
                <td>
                  <div className="avatar">
                    <div className="w-16 h-16">
                      <img src={product.imageSample} alt={product.title} />
                    </div>
                  </div>
                </td>
                <td className="py-3 px-5">{product.local}</td>
                <td className="py-3 px-5">{product.priceInCents}</td>
                <td className="py-3 px-5">{product.tags}</td>
                <td className="py-3 px-5">{product.atletaNome}</td>
                <td className="py-3 px-5">{product.evento}</td>
                <td className="py-3 px-5">
                  <div className="flex justify-center gap-x-1">
                    <Link
                      to={`/admin/product/edit/${product._id}`}
                      className="bg-orange-500 hover:bg-orange-900
                 text-white py-2 px-4 font-medium rounded-l-lg text-sm"
                    >
                      Editar
                    </Link>

                    <Link
                      to={`/admin/product/delete/${product._id}`}
                      className="bg-red-500 hover:bg-red-900
                 text-white py-2 px-4 font-medium rounded-r-lg text-sm"
                    >
                      Remover
                    </Link>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Admin;
